import { CalculationGgForm } from '../model/business/calculation/CalculationForm';
import { MainOccupationDto } from '../model/business/application/MainOccupationDto';
import { PersonalDetails } from '../model/business/application/PersonalDetails';
import { InsuredDetails } from '../model/business/application/InsuredDetails';
import { BaseOption } from '../model/BaseOption';

export class SessionGgService {
  private applicationFormValues: any;
  private calculatorFormValues = null;
  private calculationFormValues = new CalculationGgForm();
  private insuredFormValues = new InsuredDetails();
  private personalDetailsFormValues = new PersonalDetails();
  private durationList: Array<BaseOption>;

  setCalculationPageValues(calculationFormValues: CalculationGgForm): void {
    this.calculationFormValues = calculationFormValues;
  }

  getCalculationPageValues(): CalculationGgForm {
    return this.calculationFormValues;
  }

  setApplicationFormValues(applicationFormValues: any): void {
    this.applicationFormValues = applicationFormValues;
  }

  getApplicationFormValues(): any {
    return this.applicationFormValues;
  }

  clearApplicationFormValues(): void {
    this.applicationFormValues = null;
  }

  getOccupation(): string {
    return this.calculationFormValues.occupation;
  }

  getClaimDuration(): string {
    return this.calculationFormValues.claimDuration;
  }

  getInsuredOccupation(): MainOccupationDto {
    return this.calculationFormValues.insuredOccupation;
  }

  getWaitingPeriod(): string {
    return this.calculationFormValues.waitingPeriod;
  }

  getMentalIllness(): string {
    return this.calculationFormValues.mentalIllness;
  }

  getIndexationUsage(): string {
    return this.calculationFormValues.indexationUsage;
  }

  setInsuredFormValues(insured: InsuredDetails): void {
    this.insuredFormValues = insured;
  }

  get getInsuredFormValues(): InsuredDetails {
    return this.insuredFormValues;
  }

  setPersonalDetailsFormValues(personalDetails: PersonalDetails): void {
    this.personalDetailsFormValues = personalDetails;
  }

  get getPersonalDetailsFormValues(): PersonalDetails {
    return this.personalDetailsFormValues;
  }

  get getSumAssured(): string {
    return this.calculationFormValues.sumAssured;
  }

  setCalculatorFormValues(calculatorFormValues): void {
    this.calculatorFormValues = calculatorFormValues;
  }

  get getCalculatorFormValues(): any {
    return this.calculatorFormValues;
  }

  clearCalculationFormValues(): void {
    this.calculationFormValues = new CalculationGgForm();
  }

  clearInsuredFormValues(): void {
    this.insuredFormValues = new InsuredDetails();
  }

  clearPersonalDetailsFormValues(): void {
    this.personalDetailsFormValues = new PersonalDetails();
  }

  resetApplication(): void {
    this.clearApplicationFormValues();
    this.clearCalculationFormValues();
    this.clearInsuredFormValues();
    this.clearPersonalDetailsFormValues();
  }

  setDurationList(durationList): void {
    this.durationList = durationList;
  }

  get getDurationList(): any {
    return this.durationList;
  }
}
